export default __webpack_public_path__ + "static/media/cold-mocha.18651467.png";